var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, AutocompleteOption, ListItemContent, Typography, } from "@mui/joy";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { createElement, useEffect, useState, useMemo, } from "react";
import { usePopup } from "@/hooks/layout";
import { useLogger } from "@/utils/loggerService";
import { setModuleList } from "@/store/layoutSlice";
import { useAppDispatch } from "@/hooks/store";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function WidgetSelectorStudio(_a) {
    var _b;
    var widget = _a.widget, _c = _a.layout, layout = _c === void 0 ? "list" : _c, setSelected = _a.setSelected;
    var closePopup = usePopup().closePopup;
    var uuidv4 = require("uuid").v4;
    var logger = useLogger().logger;
    var dispatch = useAppDispatch();
    var t = useTranslation(["common"]).t;
    var _d = useState(false), disabled = _d[0], setDisabled = _d[1];
    var isEditMode = (widget === null || widget === void 0 ? void 0 : widget.mode) === "edit";
    var widgetId = widget === null || widget === void 0 ? void 0 : widget.id;
    var handleEditDone = (_b = widget.payload) === null || _b === void 0 ? void 0 : _b.onEditDone;
    var moduleName = useParams().moduleName;
    var entries = useMemo(function () {
        return widgetsDictionary.entries().filter(function (wd) {
            var _a;
            var isSelectable = wd[1].selectable === undefined || wd[1].selectable === true;
            var isNotVerticalMenu = !(((_a = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _a === void 0 ? void 0 : _a.direction) === "HORIZONTAL" &&
                wd[1].name === "Simple menu");
            return isSelectable && isNotVerticalMenu;
        });
    }, [widget]);
    var _e = useState(null), selection = _e[0], setSelection = _e[1];
    var _f = useState(), selectedWidget = _f[0], setSelectedWidget = _f[1];
    useEffect(function () {
        if (!isEditMode)
            return;
        var found = entries.find(function (_a) {
            var key = _a[0];
            return key === widget.type;
        });
        if (!found)
            return;
        setSelection(found);
        setSelectedWidget({
            id: widget.id,
            type: widget.type,
            payload: __assign({}, widget.payload),
        });
    }, [isEditMode, widget, entries]);
    useEffect(function () {
        var _a;
        if (!selection) {
            setSelectedWidget(undefined);
            return;
        }
        if (isEditMode) {
            setSelectedWidget(function (prev) { return ({
                id: (prev === null || prev === void 0 ? void 0 : prev.id) || widget.id,
                type: selection[0],
                payload: (prev === null || prev === void 0 ? void 0 : prev.payload) || __assign({}, widget.payload),
            }); });
            return;
        }
        setSelectedWidget({
            id: "",
            type: selection[0],
            payload: {
                currentTotalColspan: ((_a = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _a === void 0 ? void 0 : _a.currentTotalColspan) || 0,
            },
        });
    }, [selection, isEditMode, widget]);
    var widgetDefinition = selection === null || selection === void 0 ? void 0 : selection[1];
    function isEmptyOrHasNullValues(payload) {
        if (!payload)
            return true;
        if (Object.keys(payload).length === 0)
            return true;
        return Object.values(payload).some(function (v) { return v === null; });
    }
    useEffect(function () {
        if (!(widgetDefinition === null || widgetDefinition === void 0 ? void 0 : widgetDefinition.validation))
            return;
        setDisabled(isEmptyOrHasNullValues(selectedWidget === null || selectedWidget === void 0 ? void 0 : selectedWidget.payload));
    }, [widgetDefinition, selectedWidget]);
    return (_jsxs("div", __assign({ className: "flex flex-col overflow-auto" }, { children: [_jsx("div", __assign({ className: "mx-4 my-5" }, { children: _jsx(Autocomplete, { options: entries, value: selection, 
                    // disabled={isEditMode}
                    placeholder: String(t("app.LBL_SEARCH_WIDGET", { ns: "common" })), getOptionLabel: function (option) { return option[1].name || option[0]; }, renderOption: function (props, option) { return (_jsx(AutocompleteOption, __assign({}, props, { children: _jsx(ListItemContent, { children: option[1].name }) }))); }, isOptionEqualToValue: function (option, value) { return option[0] === value[0]; }, onChange: function (_, value) {
                        setSelection(value);
                    } }) })), selection && (_jsxs("div", __assign({ className: "flex flex-col w-full" }, { children: [_jsxs(Typography, { children: [t("app.LBL_WIDGET_SETTINGS", { ns: "common" }), " :", " ", selection[1].name] }), (widgetDefinition === null || widgetDefinition === void 0 ? void 0 : widgetDefinition.settings) &&
                        createElement(widgetDefinition.settings, {
                            widget: selectedWidget,
                            onChange: function (_widget, payload) {
                                setSelectedWidget(function (prev) {
                                    if (!prev)
                                        return prev;
                                    return __assign(__assign({}, prev), { payload: __assign(__assign({}, prev.payload), payload) });
                                });
                            },
                        })] }))), layout === "list" && (_jsxs("div", __assign({ className: "flex mt-8 mb-4 text-center md:text-right md:justify-end ".concat(disabled ? "cursor-not-allowed" : "") }, { children: [_jsx("div", { children: _jsx("button", __assign({ className: "button secondary block w-full px-4 py-3 text-sm font-semibold md:inline-block md:w-auto md:py-2 md:mt-0 md:order-1", onClick: function () {
                                setSelection(null);
                                setSelectedWidget(undefined);
                                if (handleEditDone) {
                                    handleEditDone();
                                }
                                logger.debug("[WIDGET SELECTOR] - Cancel", selectedWidget);
                            } }, { children: t("app.LBL_CANCEL", { ns: "common" }) })) }), _jsx("div", { children: _jsx("button", __assign({ className: "block button danger w-full px-4 py-3 text-sm font-semibold ".concat(disabled ? "text-gray-400 bg-gray-200 disabled" : "", " md:inline-block md:w-auto md:py-2 md:ml-2"), disabled: disabled, onClick: function () {
                                if (!selection || !selectedWidget)
                                    return;
                                var updatedWidget = __assign(__assign({}, selectedWidget), { id: isEditMode && selectedWidget.id
                                        ? selectedWidget.id
                                        : uuidv4() });
                                dispatch(setModuleList({
                                    widget: updatedWidget,
                                    module: moduleName,
                                    mode: isEditMode ? "edit" : "add",
                                }));
                                logger.debug("[WIDGET SELECTOR] - ".concat(isEditMode ? "EDIT" : "ADD"), updatedWidget);
                                setSelection(null);
                                setSelectedWidget(undefined);
                                if (handleEditDone) {
                                    handleEditDone();
                                }
                            } }, { children: isEditMode
                                ? t("app.LBL_EDIT_BUTTON", { ns: "common" })
                                : t("app.LBL_WIDGET_SELECT", { ns: "common" }) })) })] }))), layout === "detail" && (_jsx("div", __assign({ className: "flex mt-8 mb-4 text-center md:text-right md:justify-end ".concat(disabled ? "cursor-not-allowed" : "") }, { children: _jsx("div", { children: _jsx("button", __assign({ className: "block button small w-full px-4 py-3 text-sm font-semibold ".concat(disabled ? "text-gray-400 bg-gray-200 disabled" : "", " md:inline-block md:w-auto md:py-2 md:ml-2"), disabled: disabled, onClick: function () {
                            if (!selection || !selectedWidget)
                                return;
                            var updatedWidget = __assign(__assign({}, selectedWidget), { id: isEditMode && selectedWidget.id
                                    ? selectedWidget.id
                                    : uuidv4() });
                            setSelected && setSelected(updatedWidget);
                        } }, { children: t("app.LBL_ETC_CONFIRM", { ns: "common" }) })) }) })))] })));
}
// REGISTER
widgetsDictionary.register("widget/selector-studio", {
    name: "Selecteur de widget",
    display: WidgetSelectorStudio,
    selectable: false,
    editable: false,
});
